import { useEffect, useState } from "react";
import { DataHora } from "./Grid";
import styled from "styled-components";
import api from "../api";
import axios from "axios";

const isProd = process.env.NODE_ENV === "production";
const API_URL = isProd
  ? "https://api.assaicartola2.shop/api/"
  : "http://localhost:5137/api/";

const BtnAprovar = styled.button`
  margin-top: 4px;
  padding: 6px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  font-size: 0.85rem;
  background: ${p => p.variant === "pago" ? "#27ae60" : p.variant === "rejeitado" ? "#c0392b" : "#2980b9"};
  color: #fff;
  &:hover { opacity: 0.85; }
  &:disabled { background: #aaa; cursor: not-allowed; }
`;

const SaquePendenteBox = styled.div`
  border: 2px solid #f39c12;
  border-radius: 8px;
  background: #fef9e7;
  padding: 10px 14px;
  margin-bottom: 10px;
`;

const BadgeStatus = styled.span`
  display: inline-block;
  margin-top: 6px;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 0.78rem;
  font-weight: bold;
  background: ${p =>
    p.status === "PAGO"        ? "#d5f5e3" :
    p.status === "PENDENTE"    ? "#fef9e7" :
    p.status === "PROCESSANDO" ? "#d6eaf8" :
    p.status === "REJEITADO"   ? "#f9ebea" : "#eee"};
  color: ${p =>
    p.status === "PAGO"        ? "#1e8449" :
    p.status === "PENDENTE"    ? "#b7950b" :
    p.status === "PROCESSANDO" ? "#1a5276" :
    p.status === "REJEITADO"   ? "#922b21" : "#777"};
`;

const ExtratoItem = styled.div`
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color:  ${props => props.movimento === 2 ? '#d4edda' : '#ffe5e5'};
`;

const Linha = styled.div`
  margin-bottom: 4px;
  font-size: 16px;
`;

const LinhaCenter = styled.div`
  margin-bottom: 4px;
  font-size: 16px;
  text-align: center;
`;




/*

async function DadosUsuario(idUsuario) {
  try {
    const res = await api.get("liga/dadosUsuario/"+idUsuario);
    setUsuario(res.data);
  } catch (error) {
    //toast.error(error.message);
  }
};*/


const DescricaoFinanceiro = ({ financeiro, adm }) => {

  const [usuario, setUsuario] = useState(null);
  // lista de saques pendentes do usuário (apenas para admin)
  const [saquesPendentes, setSaquesPendentes] = useState([]);
  const [processando, setProcessando] = useState({});

  const getDados = async () => {
    try {
      const res = await api.get("liga/dadosUsuario/" + financeiro[0].idUsuario);
      setUsuario(res.data);
    } catch (error) {}
  };

  const carregarSaquesPendentes = async () => {
    if (!adm || !financeiro?.length) return;
    try {
      const idUsuario = financeiro[0].idUsuario;
      const res = await axios.get(`${API_URL}liga/admin/saquesPendentes/${idUsuario}`);
      setSaquesPendentes(res.data || []);
    } catch (err) {
      console.error("Erro ao carregar saques pendentes:", err);
    }
  };

  useEffect(() => {
    getDados();
    carregarSaquesPendentes();
  }, [financeiro]);

  async function aprovarSaque(saqueId) {
    setProcessando(p => ({ ...p, [saqueId]: true }));
    try {
      const res = await axios.post(`${API_URL}liga/admin/saques/${saqueId}/aprovar`);
      const { chavePix, valor, nomeUsuario } = res.data;
      setSaquesPendentes(prev => prev.filter(s => s.id !== saqueId));
      const valorFmt = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(valor);
      alert(
        `Saque aprovado!\n\nFaca a transferencia PIX manualmente:\n\nUsuario: ${nomeUsuario}\nValor: ${valorFmt}\nChave PIX: ${chavePix}\n\nCopie a chave e transfira pelo app do Mercado Pago.`
      );
    } catch (err) {
      const msg = err?.response?.data?.message || "Erro ao aprovar saque.";
      alert("Erro: " + msg);
    } finally {
      setProcessando(p => ({ ...p, [saqueId]: false }));
    }
  }

  async function rejeitarSaque(saqueId) {
    setProcessando(p => ({ ...p, [saqueId]: true }));
    try {
      await axios.put(`${API_URL}liga/admin/saques/${saqueId}/status`, { status: "REJEITADO", observacao: "Rejeitado pelo admin" });
      setSaquesPendentes(prev => prev.filter(s => s.id !== saqueId));
    } catch {
      alert("Erro ao rejeitar saque.");
    } finally {
      setProcessando(p => ({ ...p, [saqueId]: false }));
    }
  }

    return (
        <>
          <br/><ExtratoItem movimento={(usuario?.valor ?? 0) >= 0 ? 2 : 1} key={1}>
          <LinhaCenter><strong>Saldo Atualizado: </strong>{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(usuario?.valor ?? 0)}</LinhaCenter>
          </ExtratoItem>

          {/* Seção admin: saques aguardando aprovação */}
          {adm && saquesPendentes.length > 0 && (
            <div style={{ marginBottom: 16 }}>
              <strong style={{ color: "#d35400" }}>Saques aguardando aprovacao ({saquesPendentes.length})</strong>
              {saquesPendentes.map(s => (
                <SaquePendenteBox key={s.id}>
                  <div><strong>Saque ID:</strong> {s.id}</div>
                  <div><strong>Valor:</strong> {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(s.valor)}</div>
                  <div><strong>Chave PIX:</strong> {s.chavePix}</div>
                  <div><strong>Status:</strong> {s.status}</div>
                  <div><strong>Data:</strong> {DataHora(s.dtSolicitacao)}</div>
                  <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                    <BtnAprovar
                      variant="pago"
                      disabled={processando[s.id]}
                      onClick={() => aprovarSaque(s.id)}
                    >
                      {processando[s.id] ? "Enviando PIX..." : "Aprovar (Enviar PIX)"}
                    </BtnAprovar>
                    <BtnAprovar
                      variant="rejeitado"
                      disabled={processando[s.id]}
                      onClick={() => rejeitarSaque(s.id)}
                    >
                      {processando[s.id] ? "..." : "Rejeitar"}
                    </BtnAprovar>
                  </div>
                </SaquePendenteBox>
              ))}
            </div>
          )}

            { financeiro.map((f) => (
                <ExtratoItem key={f.id} movimento={f.movimento}>
                <Linha><strong>Id:</strong> {f.id}</Linha>
                <Linha><strong>Data:</strong> {DataHora(f.data)}</Linha>
                <Linha><strong>Movimento:</strong> {f.movimento} {f.proxyMovimento}</Linha>
                <Linha><strong>Descricao:</strong> {f.descricaoMovimento}</Linha>
                <Linha><strong>Valor:</strong> {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(f.valor)}</Linha>
                </ExtratoItem>
            ))}
        </>
    )
}

export default DescricaoFinanceiro;